import { createFileRoute } from '@tanstack/react-router'

import { McpSettingsPage } from '@/features/integrations/mcp-settings-page'

export const Route = createFileRoute('/_app/integracoes/mcp')({
  component: McpSettingsPage,
})
